import React from "react";
import { Button, Select } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import {
  AGENT_FILTER_SELECT_PROPS,
  AgentFilterToolbar,
} from "./AgentFilterToolbar";

interface AgentContainersFiltersProps {
  search: string;
  transportFilter?: number;
  originFilter?: number;
  destinationFilter?: number;
  masterFilter?: number | "none";
  groupByMaster: boolean;
  transportTypes: { id: number; name: string }[];
  originPorts: { id: number; name: string }[];
  destinationPorts: { id: number; name: string }[];
  masterOptions: { id: number; reference: string | null }[];
  hasActiveFilters: boolean;
  resultCount: number;
  onSearchChange: (value: string) => void;
  onTransportChange: (value?: number) => void;
  onOriginChange: (value?: number) => void;
  onDestinationChange: (value?: number) => void;
  onMasterChange: (value?: number | "none") => void;
  onGroupByMasterChange: (value: boolean) => void;
  onClearFilters: () => void;
  onRefresh: () => void;
  onAddContainer: () => void;
}

export const AgentContainersFilters: React.FC<AgentContainersFiltersProps> = ({
  search,
  transportFilter,
  originFilter,
  destinationFilter,
  masterFilter,
  groupByMaster,
  transportTypes,
  originPorts,
  destinationPorts,
  masterOptions,
  hasActiveFilters,
  resultCount,
  onSearchChange,
  onTransportChange,
  onOriginChange,
  onDestinationChange,
  onMasterChange,
  onGroupByMasterChange,
  onClearFilters,
  onRefresh,
  onAddContainer,
}) => (
  <AgentFilterToolbar
    search={search}
    searchPlaceholder="Search reference…"
    onSearchChange={onSearchChange}
    hasActiveFilters={hasActiveFilters}
    onClearFilters={onClearFilters}
    onRefresh={onRefresh}
    resultCount={resultCount}
    actions={
      <Button
        size="small"
        type="primary"
        icon={<PlusOutlined />}
        onClick={onAddContainer}
      >
        Add container
      </Button>
    }
  >
    <Select
      {...AGENT_FILTER_SELECT_PROPS}
      placeholder="Transport"
      value={transportFilter}
      onChange={onTransportChange}
      options={transportTypes.map((t) => ({ value: t.id, label: t.name }))}
    />
    <Select
      {...AGENT_FILTER_SELECT_PROPS}
      showSearch
      optionFilterProp="label"
      placeholder="Master BL/AWB"
      value={masterFilter}
      onChange={onMasterChange}
      options={[
        { value: "none", label: "No Master BL/AWB" },
        ...masterOptions.map((m) => ({
          value: m.id,
          label: m.reference || `Master #${m.id}`,
        })),
      ]}
    />
    <Select
      {...AGENT_FILTER_SELECT_PROPS}
      showSearch
      optionFilterProp="label"
      placeholder="Origin"
      value={originFilter}
      onChange={onOriginChange}
      options={originPorts.map((p) => ({ value: p.id, label: p.name }))}
    />
    <Select
      {...AGENT_FILTER_SELECT_PROPS}
      showSearch
      optionFilterProp="label"
      placeholder="Destination"
      value={destinationFilter}
      onChange={onDestinationChange}
      options={destinationPorts.map((p) => ({ value: p.id, label: p.name }))}
    />
    <Select
      {...AGENT_FILTER_SELECT_PROPS}
      placeholder="Group by"
      value={groupByMaster ? "master" : undefined}
      onChange={(value) => onGroupByMasterChange(value === "master")}
      options={[{ value: "master", label: "Master BL/AWB" }]}
    />
  </AgentFilterToolbar>
);
